import firebase from "firebase";
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyCZECcDK5lVeUegsjEOebIR2SVohH3-rI4",
  // authDomain: "sbgonlinestore-2020.firebaseapp.com",
  authDomain: "auth.biblias.gt",
  databaseURL: "https://sbgonlinestore-2020.firebaseio.com",
  projectId: "sbgonlinestore-2020",
  storageBucket: "sbgonlinestore-2020.appspot.com",
  messagingSenderId: "14738606269",
  appId: "1:14738606269:web:9135451d5d07b20b394fd4",
  measurementId: "G-8NZS1PXT0Y"
};

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const storage = firebase.storage();
const storageRef = storage.ref();
const auth = firebase.auth();

// firebase collections
// const categories = db.collection('categories');

export {
  firebase,
  db,
  storage,
  storageRef,
  auth
  // categories
}
